['click', 'touchstart', 'touchend'].forEach((e) => {
    document.querySelector('#site__menu-button').addEventListener(e, () => {
        let a = document.querySelector('#site__menu-button'),
            b = document.querySelector('#site__menu');

        a.classList.toggle('active');
        b.classList.toggle('active');
        (b.classList.contains('active')) ? document.body.style.position = "fixed" : document.body.removeAttribute("style");
        (b.classList.contains('active')) ? document.querySelector('#site__header').style.backgroundColor = "#fff" : document.querySelector('#site__header').style.backgroundColor = null;

    });
});

const toggle = (e) => {
    document.getElementById('req')
        .classList.toggle('show');
    e.stopPropagation();
};

const bodyHandle = (e) => {
    if (document.getElementById('req')
        .classList.contains('show')) {
        document.getElementById('req')
            .classList.toggle('show');
    }
};

['load', 'resize'].forEach((e) => {
    window.addEventListener(e, () => {
        const h = document.querySelector('#site__header').offsetHeight,
            el = document.querySelectorAll('.site__wrapper');
        for (let i = 0; i < el.length; i++) {
            (el[i].getAttribute('id') !== 'site__header' && el[i].getAttribute('id') !== 'site__footer') ? el[i].style.paddingTop = `${h}px` : '';
            (el[i].getAttribute('id') === 'site__financial') ? el[i].style.paddingBottom = `${h}px` : '';
            (el[i].getAttribute('id') === 'site__case-study') ? el[i].style.marginBottom = `${h}px` : '';
        }
    });
});
const h = document.querySelector('#site__header').offsetHeight,
    pinElement = document.querySelectorAll("[data-pin]"),
    pinContainer = document.querySelectorAll("[data-pin-container]");

ScrollTrigger.create({
    trigger: pinContainer,
    // markers: true,
    start: `top top+=${h}px`,
    end: "bottom bottom",
    pin: pinElement,
    pinSpacing: false,
    onToggle: scrollTrigger => {
        // refresh because height start changes
        scrollTrigger.refresh()
    }
});

document.querySelectorAll('.site__card-hover').forEach(target => {
    let arr = ["hotel", "construction", "factory", "office", "retail", "arpents"],
        i,
        len = arr.length;

    target.addEventListener('mouseover', () => {
        target.classList.add('active');
        for (i = 0; i < len; i++) {
            if (target.classList.contains(arr[i])) {
                document.querySelector(`#${arr[i]}-hover`).classList.add('active');
            }
        }
    });
    target.addEventListener('mouseout', () => {
        target.classList.remove('active');
        for (i = 0; i < len; i++) {
            if (target.classList.contains(arr[i])) {
                document.querySelector(`#${arr[i]}-hover`).classList.remove('active');
            }
        }
    });
});

const list = [...document.querySelectorAll(".site__area")];
let selectedEl;

for (const el of list) {
    el.addEventListener("click", e => {
        selectedEl && selectedEl.classList.remove("active");
        selectedEl = e.target;
        e.target.classList.add("active");
    });
}

// const features = document.querySelectorAll("[data-pin]");
// observer = new IntersectionObserver(
//     (sections) => {
//         sections.forEach((section) => {
//             if (section.intersectionRatio > 0.5) {
//                 section.target.classList.add("active");
//             } else {
//                 section.target.classList.remove("active");
//             }
//         });
//     },
//     { threshold: 0.5 }
// );

// features.forEach((feature) => observer.observe(feature));
